/**
 * Feature flags from `GET /admin/feature-flags/minimal`, published on
 * `RestaurantService.restaurantFeatureFlags$` by HomePageComponent. They
 * replace the old `configs.global_settings.features` restaurant config.
 */
export interface FeatureFlag {
  key: string;
  name: string;
  enabled: boolean;
  status: string;
  flagType: string;
}

export const FEATURE_FLAG_KEYS = {
  HARDWARE: 'HARDWARE',
  TO_GO: 'TO_GO',
  DELIVERY_PARTNERS: 'DELIVERY_PARTNERS',
  RESERVATIONS: 'RESERVATIONS',
  TAX: 'TAX',
  SQUARE: 'SQUARE',
  CLOVER: 'CLOVER',
  SWIREPAY: 'SWIREPAY',
  ADD_ON: 'ADD_ON',
  BILLING: 'BILLING',
  UBER: 'UBER',
  RESTAURANT_SETTINGS: 'RESTAURANT_SETTINGS',
  /** Restaurant → Social Media: the Fynkle Wall Profile and posts (FNF-1609). */
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
} as const;

/** A feature is on only when its flag exists and its status is ACTIVE —
 * a missing flag counts as off. */
export function isFeatureActive(flags: FeatureFlag[] | null | undefined, key: string): boolean {
  return !!flags?.some(
    (flag) => flag.key?.toUpperCase() === key && flag.status?.toUpperCase() === 'ACTIVE',
  );
}
